import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Button } from "@/components/ui/button";
import { Flame, LayoutDashboard, FileText, Package, Truck, Boxes, Settings2, LogOut, ClipboardList } from "lucide-react";

const nav = [
  { to: "/", label: "Panel", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/projects", label: "Projeler", icon: FileText, testid: "nav-projects" },
  { to: "/products", label: "Ürün Kataloğu", icon: Package, testid: "nav-products" },
  { to: "/suppliers", label: "Tedarikçiler", icon: Truck, testid: "nav-suppliers" },
  { to: "/offers", label: "Teklif Karşılaştırma", icon: ClipboardList, testid: "nav-offers" },
  { to: "/stock", label: "Stok", icon: Boxes, testid: "nav-stock" },
  { to: "/settings", label: "Ayarlar", icon: Settings2, testid: "nav-settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 border-r border-border bg-white dark:bg-slate-900 flex flex-col">
        <div className="h-16 flex items-center gap-2 px-5 border-b border-border">
          <div className="w-8 h-8 rounded-md bg-primary text-white grid place-items-center">
            <Flame size={18} strokeWidth={2} />
          </div>
          <div>
            <div className="font-heading font-black text-sm leading-none">REFRAKTER</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Teklif Sistemi</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${
                    isActive
                      ? "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground"
                      : "text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white"
                  }`
                }
              >
                <Icon size={16} strokeWidth={2} />
                <span>{n.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 text-xs">
            <div className="font-semibold truncate">{user?.name || user?.email}</div>
            <div className="text-muted-foreground uppercase tracking-widest text-[10px]">{user?.role}</div>
          </div>
          <Button
            data-testid="logout-btn"
            variant="ghost"
            size="sm"
            className="w-full justify-start text-slate-700 hover:text-slate-900 hover:bg-slate-100"
            onClick={async () => { await logout(); navigate("/login"); }}
          >
            <LogOut size={14} className="mr-2" /> Çıkış
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <div className="h-16 border-b border-border bg-white dark:bg-slate-900 sticky top-0 z-20 flex items-center px-6">
          <h1 className="font-heading font-bold text-lg" data-testid="page-title">Refrakter Birleşik Teklif Sistemi</h1>
          <div className="ml-auto text-xs text-muted-foreground uppercase tracking-widest">v1.0 — Türkçe</div>
        </div>
        <div className="p-6 animate-fade-in">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
